/**
 * useAnalytics Hook
 * Provides analytics tracking functionality
 * Must be called inside Router context
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../utils/analytics';

let gaInitialized = false;

export const useAnalytics = () => {
  // useLocation must be called unconditionally (React hooks rule)
  // This hook MUST be called inside Router context
  const location = useLocation();
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  // Initialize GA on mount
  useEffect(() => {
    if (!gaInitialized && measurementId) {
      initGA(measurementId);
      gaInitialized = true;
    }
  }, [measurementId]);

  // Track page views on route change
  useEffect(() => {
    if (measurementId && gaInitialized && location) {
      trackPageView(location.pathname + location.search);
    }
  }, [location, measurementId]);
};

export default useAnalytics;

